import React from 'react';
import { useTranslation } from 'react-i18next';
function setTranslator(t, i18n) {
    window.translationService = t;
    window.translationServiceI18N = i18n;
}
export function ShareTranslatorService() {
    var _a = useTranslation(), t = _a.t, ready = _a.ready, i18n = _a.i18n;
    if (!ready) {
        return (React.createElement("span", { style: { display: 'none' } }, "ShareTranslatorService not ready"));
    }
    setTranslator(t, i18n);
    return (React.createElement("span", { style: { display: 'none' } }, "ShareTranslatorService ready"));
}
//# sourceMappingURL=ShareTranslatorService.js.map